export const REGISTER_USER = "REGISTER_USER"
export const REGISTER_USER_SUCCESSFUL = "REGISTER_USER_SUCCESSFUL"
export const REGISTER_USER_FAILED = "REGISTER_USER_FAILED"
export const VERIFY_REGISTER_USER = "VERIFY_REGISTER_USER"
export const VERIFY_REGISTER_USER_SUCCESSFUL = "VERIFY_REGISTER_USER_SUCCESSFUL"
export const VERIFY_REGISTER_USER_FAILED = "VERIFY_REGISTER_USER_FAILED"
